/**
 * @generated SignedSource<<425e496f37c72647554a0ac4c3a281fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalScoringMode = "OKR" | "SIMPLE";
export type GoalDirectoryQuery$variables = {
  aaid?: string | null;
  containerId?: string | null;
  includeArchived: boolean;
  newGoalFilterResolversEnabled: boolean;
  workspaceId: string;
  workspaceUuid?: string | null;
};
export type GoalDirectoryQuery$data = {
  readonly customFieldDefinitionTql: {
    readonly " $fragmentSpreads": FragmentRefs<"buildCustomFieldResolvers">;
  } | null;
  readonly customfieldHeaderSupport: {
    readonly " $fragmentSpreads": FragmentRefs<"GoalDirectoryHeaderColumns">;
  } | null;
  readonly hasGoals: {
    readonly hasRecords: boolean;
  } | null;
  readonly reportingLines: {
    readonly managers: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
    readonly peers: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
    readonly reports: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
  } | null;
  readonly workspace?: {
    readonly goalScoringMode: GoalScoringMode;
  } | null;
};
export type GoalDirectoryQuery = {
  response: GoalDirectoryQuery$data;
  variables: GoalDirectoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aaid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeArchived"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newGoalFilterResolversEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "args": [
    {
      "kind": "Variable",
      "name": "aaidOrHash",
      "variableName": "aaid"
    }
  ],
  "concreteType": "ReportingLines",
  "kind": "LinkedField",
  "name": "reportingLines",
  "plural": false,
  "selections": [
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "managers",
      "plural": true,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "peers",
      "plural": true,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "reports",
      "plural": true,
      "selections": (v7/*: any*/)
    }
  ]
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "goalScoringMode"
},
v11 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v12 = {
  "args": [
    (v11/*: any*/),
    {
      "kind": "Variable",
      "name": "includeArchived",
      "variableName": "includeArchived"
    },
    {
      "kind": "Variable",
      "name": "workspaceId",
      "variableName": "workspaceId"
    }
  ],
  "concreteType": "HasRecords",
  "kind": "LinkedField",
  "name": "hasGoals",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRecords"
    }
  ]
},
v13 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v14 = [
  (v11/*: any*/),
  {
    "kind": "Literal",
    "name": "q",
    "value": "(entityType = GOAL AND (type != String OR hasPredefinedValues = true))"
  },
  (v13/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = {
  "kind": "ScalarField",
  "name": "token"
},
v17 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
},
v18 = {
  "kind": "ScalarField",
  "name": "value"
},
v19 = [
  (v11/*: any*/),
  {
    "kind": "Literal",
    "name": "q",
    "value": "entityType = GOAL"
  },
  (v13/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "name": "id"
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v20/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v22 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v23 = {
  "kind": "ScalarField",
  "name": "type"
},
v24 = [
  (v22/*: any*/),
  (v15/*: any*/),
  (v23/*: any*/)
],
v25 = [
  (v22/*: any*/),
  (v15/*: any*/),
  (v23/*: any*/),
  (v17/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalDirectoryQuery",
    "selections": [
      (v8/*: any*/),
      {
        "condition": "newGoalFilterResolversEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v10/*: any*/)
            ]
          }
        ]
      },
      (v12/*: any*/),
      {
        "args": (v14/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "buildCustomFieldResolvers",
            "selections": [
              {
                "concreteType": "CustomFieldDefinitionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_userResolver",
                            "selections": [
                              (v6/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/)
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "UserCustomFieldDefinition"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_textSelectResolver",
                            "selections": [
                              (v6/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              {
                                "concreteType": "CustomFieldTextAllowedValueConnection",
                                "kind": "LinkedField",
                                "name": "allowedValues",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextAllowedValueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v18/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "TextSelectCustomFieldDefinition"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_numberResolver",
                            "selections": [
                              (v6/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/)
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "NumberCustomFieldDefinition"
                      }
                    ]
                  }
                ]
              }
            ],
            "argumentDefinitions": []
          }
        ]
      },
      {
        "alias": "customfieldHeaderSupport",
        "args": (v19/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "GoalDirectoryHeaderColumns"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalDirectoryQuery",
    "selections": [
      (v8/*: any*/),
      (v12/*: any*/),
      {
        "args": (v14/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ],
                    "type": "UserCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "concreteType": "CustomFieldTextAllowedValueConnection",
                        "kind": "LinkedField",
                        "name": "allowedValues",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CustomFieldTextAllowedValueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "CustomFieldTextAllowedValueNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  (v20/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "TextSelectCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ],
                    "type": "NumberCustomFieldDefinition"
                  },
                  (v21/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "customfieldHeaderSupport",
        "args": (v19/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v24/*: any*/),
                    "type": "NumberCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v24/*: any*/),
                    "type": "TextCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v25/*: any*/),
                    "type": "TextSelectCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v25/*: any*/),
                    "type": "UserCustomFieldDefinition"
                  },
                  (v21/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "newGoalFilterResolversEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v20/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "201dd9873978d7c38a07b3f8214db719",
    "id": null,
    "metadata": {},
    "name": "GoalDirectoryQuery",
    "operationKind": "query",
    "text": "query GoalDirectoryQuery(\n  $aaid: String\n  $workspaceId: ID!\n  $workspaceUuid: UUID\n  $containerId: String\n  $newGoalFilterResolversEnabled: Boolean!\n  $includeArchived: Boolean!\n) {\n  reportingLines(aaidOrHash: $aaid) {\n    managers {\n      __typename\n    }\n    peers {\n      __typename\n    }\n    reports {\n      __typename\n    }\n  }\n  workspace(id: $workspaceId) @include(if: $newGoalFilterResolversEnabled) {\n    goalScoringMode\n    id\n  }\n  hasGoals(includeArchived: $includeArchived, workspaceId: $workspaceId, containerId: $containerId) {\n    hasRecords\n  }\n  customFieldDefinitionTql(q: \"(entityType = GOAL AND (type != String OR hasPredefinedValues = true))\", workspaceUuid: $workspaceUuid, containerId: $containerId) {\n    ...buildCustomFieldResolvers\n  }\n  customfieldHeaderSupport: customFieldDefinitionTql(q: \"entityType = GOAL\", workspaceUuid: $workspaceUuid, containerId: $containerId) {\n    ...GoalDirectoryHeaderColumns\n  }\n}\n\nfragment GoalDirectoryHeaderColumns on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on NumberCustomFieldDefinition {\n        uuid\n        name\n        type\n      }\n      ... on TextCustomFieldDefinition {\n        uuid\n        name\n        type\n      }\n      ... on TextSelectCustomFieldDefinition {\n        uuid\n        name\n        type\n        canSetMultipleValues\n      }\n      ... on UserCustomFieldDefinition {\n        uuid\n        name\n        type\n        canSetMultipleValues\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on UserCustomFieldDefinition {\n        ...buildCustomFieldResolvers_userResolver\n      }\n      ... on TextSelectCustomFieldDefinition {\n        ...buildCustomFieldResolvers_textSelectResolver\n      }\n      ... on NumberCustomFieldDefinition {\n        ...buildCustomFieldResolvers_numberResolver\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers_numberResolver on NumberCustomFieldDefinition {\n  __typename\n  name\n  token\n}\n\nfragment buildCustomFieldResolvers_textSelectResolver on TextSelectCustomFieldDefinition {\n  __typename\n  name\n  token\n  canSetMultipleValues\n  allowedValues {\n    edges {\n      node {\n        value\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers_userResolver on UserCustomFieldDefinition {\n  __typename\n  name\n  token\n  canSetMultipleValues\n}\n"
  }
};
})();

(node as any).hash = "2df3e2ec209a41c7bb933f429661f2b5";

export default node;
